export const messages = {
  page: {
    title: {
      id: 'downloadableForms.Page.Title',
      defaultMessage: 'Download Forms',
    },
    getPdfViewer: {
      id: 'downloadableForms.Page.GetPdfViewer',
      defaultMessage: 'Download the Adobe Acrobat Reader',
    },
    linkHrefPdfViewer: {
      id: 'link.Href.PdfViewer',
      defaultMessage: 'https://get.adobe.com/reader/',
    },
  },
  download: {
    size: {
      id: 'downloadableForms.Download.Size',
      defaultMessage: '({size} KB)',
    },
  },
};
